import debounce from '@hc-frontend/shared-assets/src/js/utils/fp/debounce'
import getCoverageDuration from 'core/services/getCoverageDuration'
import subscribeAndSaveApplicant from './subscribeAndSaveApplicant'
import renderSummary from '../components/summary/renderSummary'
import initializerControllers from './initializerControllers'
import getURLProfile from 'utils/pivot/member/getURLProfile'
import permittedRoutes from 'core/constants/permittedRoutes'
import { UHCStateAcronyms } from 'core/constants/UHCStates'
import validateRoute from 'utils/validation/validateRoute'
import getFiltersFromUrl from 'core/DOM/getFiltersFromUrl'
import addEventListener from 'utils/DOM/addEventListener'
import ifNotTrueExecute from 'utils/ifNotTrueExecute'
import initConnectMe from 'core/controllerConnectMe'
import scrollToError from 'core/DOM/scrollToError'
import {
  dateToString,
  stringToDate,
  stringToAge,
  alterDate,
  propAccessor
} from '@hc-frontend/utils'
import renderPlansCount from './renderPlansCount'
import getURLParams from 'utils/DOM/getURLParams'
import { DOMAIN } from 'core/constants/endpoints'
import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import { isArray } from '@hc-frontend/utils'
import handleMembers from './handleMembers'
import innerHTML from 'utils/DOM/innerHTML'
import showZipCode from '../showZipCode'
import setUpRouter from './setUpRouter'
import { QUOTES } from 'sites/routes'
import preserveMarketingParams from 'utils/DOM/preserveMarketingParams'
import forEach from 'utils/DOM/forEach'
import storage from 'proxy-storage'
import config from './../config'
import { deepClone } from '@hc-frontend/utils'
import { findApplicant } from '@hc-frontend/business'
import { preventOnCloseEvent } from 'core/services/onClose'
import clickEventName from 'utils/DOM/clickEventName'
import setAttribute from 'utils/DOM/setAttribute'
import { buildSpValue } from '../utils/snowplow'
import { DTC_DEFAULT_SORT } from 'core/constants/environment'
import store from 'utils/store/withMiddleware'
import { getVariant } from 'core/experiment'
import submitLead from './submitLead'
import { REQUIRE_PHONE_NUMBER } from 'core/constants/experiments'
import { enableMultiCarrierPlans } from 'utils/experiments'
import sessionHandler from 'core/controllers/sessionHandler'
import getSalesChannel from 'utils/pivot/environment/getSalesChannel'
import isSalesCenterSubDomain from 'utils/pivot/isSalesCenterSubDomain'
import mqDesktop from 'core/DOM/matchDesktop'

const settingsDcp = require('core/constants/timeSettings.ts').ACA

const urlParams = getURLParams()
let controllers = null
let router = null
const valuesForm = {}
const coverageStartOption = ''
let showPhoneInput = false
let showOver65GapPage = true
let noCoverage = false
const $body = $('body')
const buttonSubmitId = '#continue-form'

function isPivotDTCMobileExperience() {
  return getSalesChannel() === 'DTC' && !isSalesCenterSubDomain() && !mqDesktop.matches
}

function enableDCPButton() {
  forEach('.js-dcp-btn', btn => {
    if (btn) {
      btn.disabled = false
    }
  })
}

function validateRedirect(url: string): string {
  const [route, search] = url.split('?')
  const validRoute = validateRoute(route, permittedRoutes, permittedRoutes._default)

  if (validRoute !== route || search == null) {
    return validRoute
  }

  return `${validRoute}?${search}`
}

function getMultiCarrierRoute() {
  const eligibilityMonths = store.getState().eligibilityMonths
  const multiCarrierSelected = document.querySelector(
    '[id="select-multi-carrier-yes"]:checked'
  )
  let months: number
  let maxDuration: number

  if (multiCarrierSelected) {
    months = eligibilityMonths
    maxDuration = eligibilityMonths
  } else {
    months = 4
    maxDuration = eligibilityMonths
  }
  const queryParameters = { months: months, maxDuration: maxDuration }
  return queryParameters
}

/**
 * Assemble the /quotes/ target from query fragments, each already `&`-joined.
 * Empty fragments are dropped, and the query is appended exactly once so the
 * result is always well-formed and safe to merge campaign params into.
 */
function buildQuotesTarget(queryParts: Array<string>): string {
  const query = queryParts.filter(Boolean).join('&')
  return query ? `${QUOTES}?${query}` : QUOTES
}

function finishAndNavigate() {
  window.dataLayerPushEvent('SUBMIT_CENSUS')

  const dcpOption = document.querySelector('[name="dcp"]:checked')

  if (dcpOption && dcpOption.value === 'yes') {
    const urlProfile = getURLProfile({
      addPlanId: false,
      placement: config.placement,
      addProfile: false
    })

    // PPI-1770: keep the campaign params. The profile query is built from state
    // here, so the merge lets it win over anything inherited.
    window.location = preserveMarketingParams(
      `${DOMAIN}/customize-short-term-health-insurance/initial/?${urlProfile}`
    )
    return
  }

  // PPI-1770: census -> quotes is the highest-traffic hop in this funnel and it
  // dropped the campaign entirely, because the target is assembled from scratch
  // rather than derived from the current URL.
  //
  // The query parts are joined with `&` and appended once. They used to be
  // `.join('?')`, which produced a malformed `QUOTES?type=x&sort=y?months=…`
  // whenever a filter param was present in the URL — everything after the second
  // `?` landed inside the previous param's value. Merging requires one
  // well-formed query, so that is fixed here rather than preserved.
  if (enableMultiCarrierPlans()) {
    const queryParameters = getMultiCarrierRoute()
    window.location = urlParams.backTo
      ? preserveMarketingParams(
          updatePeriodToPath(validateRedirect(urlParams.backTo), valuesForm.period)
        )
      : preserveMarketingParams(
          buildQuotesTarget([
            getFiltersFromUrl(),
            `months=${queryParameters.months}&maxDuration=${queryParameters.maxDuration}&sort=${DTC_DEFAULT_SORT}`
          ])
        )
  } else {
    window.location = urlParams.backTo
      ? preserveMarketingParams(
          updatePeriodToPath(validateRedirect(urlParams.backTo), valuesForm.period)
        )
      : preserveMarketingParams(buildQuotesTarget([getFiltersFromUrl()]))
  }
}

export function initPhoneInput(dob: string, variant: 'control' | 'treatment') {
  if (isPivotDTCMobileExperience()) {
    showPhoneInput = true
    toggleClass('#phone-container', 'd-none', false)
    return
  }

  const userAgeAtStartOfPlan = dob
    ? stringToAge(dateToString(alterDate({ date: stringToDate(dob), days: 2 })))
    : 0
  if (variant === 'treatment') {
    showPhoneInput = userAgeAtStartOfPlan >= 18
    toggleClass('#phone-container', 'd-none', !showPhoneInput)
  } else {
    showPhoneInput = userAgeAtStartOfPlan >= 40
    toggleClass('#phone-container', 'd-none', !showPhoneInput)
  }
}

export function init({ location, hcStorage }) {
  handleMembers.init()

  controllers = initializerControllers(
    document.forms.form,
    handleUpdateLocation,
    location.county
  )

  initConnectMe({ placement: 'step-gap-page', hcStorage })

  router = setUpRouter(controllers)
  router.check()
  const requirePhoneNumberVariant = getVariant({
    experimentKey: REQUIRE_PHONE_NUMBER,
    fallback: 'control',
    trackExposure: true
  }) as 'control' | 'treatment'

  const configurePhoneInput = () => {
    const dob = controllers?.dob?.getStatus().value
    initPhoneInput(dob, requirePhoneNumberVariant)
  }

  $body
    .on('change.dcp', '[name="dcp"]', enableDCPButton)
    .on('click.dcp', '.js-dcp-btn', finishAndNavigate)
    .on('change', '[name="dob"]', configurePhoneInput)
    .on('blur', '[name="dob"]', configurePhoneInput)

  if (isPivotDTCMobileExperience()) {
    showPhoneInput = true
    toggleClass('#phone-container', 'd-none', false)
  }

  /*
    The submit event was execute after the click event triggered by snowplow.
    It had to be changed to click event in order to prepare the data that snowplow uses.
  */
  addEventListener(buttonSubmitId, clickEventName, handleSubmit)

  // expose global functions to make optional inputs
  window.makeEmailOptional = () => {
    if (!isPivotDTCMobileExperience()) {
      makeFieldOptional('email')
    }
  }
  window.makeFirstNameOptional = makeFieldOptional.bind(undefined, 'fname')
  if (!isPivotDTCMobileExperience()) {
    makeFieldOptional('email')
  }
  if (requirePhoneNumberVariant === 'treatment') {
    window.makePhoneOptional = () => {
      if (!isPivotDTCMobileExperience()) {
        makeFieldOptional('phone')
      }
    }
  } else {
    if (!isPivotDTCMobileExperience()) {
      makeFieldOptional('phone')
    }
  }
}

function updateView({ durationsByProduct, countByProduct }) {
  renderSummary(durationsByProduct)
  renderPlansCount(countByProduct)
}

const noCoverageLocationDataLayerEvent = debounce(() => {
  window.dataLayerPushEvent('NO_COVERAGE_LOCATION')
}, 1000)

let lastState

async function handleUpdateLocation(hcStorage, appState = {}) {
  const state = hcStorage.location.state_acronym

  if (state && lastState != state) {
    lastState = state
    const responseCoverage = await getCoverageDuration(hcStorage.location.state_acronym)

    const { error, data } = responseCoverage
    const notCoverage = error || !data.existCoverage
    const period = data.coverage[hcStorage.period] ? +hcStorage.period : data.longerPeriod
    controllers.period.setValue({ data, period })
    innerHTML('.shorterPeriod', data.shorterPeriod === 90 ? 90 : 180)

    noCoverage = notCoverage
    if (notCoverage) {
      noCoverageLocationDataLayerEvent()
      toggleClass(document.body, 'no-coverage', true)
    } else {
      const coveragePeriod = data.maxDurationInDays / data.longerPeriod
      const maxPeriod =
        data.longerPeriod === 364
          ? `${coveragePeriod} year${coveragePeriod > 1 ? 's' : ''}`
          : `${data.maxDurationInDays} days`

      textContent('.js-max-duration', maxPeriod)
      updateView(data)
      toggleClass(document.body, 'no-coverage', false)
    }

    if (
      notCoverage ||
      (isArray(appState.lastLocations) && appState.lastLocations.length > 1)
    ) {
      showZipCode()
    }

    if (data.date) {
      const serverStartDate = alterDate({
        date: stringToDate(data.date.replace(/ .*$/, '')),
        days: 2
      })

      const sdate = stringToDate(hcStorage.sdate)
      if (sdate.getTime() < serverStartDate.getTime()) {
        const newStorage = deepClone(hcStorage)
        newStorage.sdate = dateToString(serverStartDate)
        storage.setItem('hc', newStorage)
      }
    }
  }
}

function updatePeriodToPath(url, period) {
  let path
  try {
    path = url.replace(/^(.*>)(\d+)(-months)$/, `$1${Math.round(period / 30)}$3`)
  } catch (e) {
    path = url
  }

  return path
}

const saveSession = sessionHandler({
  useState: true,
  save: true
})

function handleSubmit(e) {
  e.preventDefault()
  $(buttonSubmitId).prop('disabled', true)
  let isValidForm = true

  const { fname, email, phone, zip, dob, gender, period, leadIdToken } = controllers
  const allControllers = {
    fname,
    email,
    phone,
    zip,
    dob,
    gender,
    period,
    leadIdToken,
    ...handleMembers.getControllers()
  }

  // The leadid_token input is hidden, so we have to manually trigger validation without user input
  leadIdToken.validate()

  // We need to make sure this runs every time for the DOB input
  dob.validate()
  showOver65GapPage = dob.getState().input.dataset.gap === 'gap65'

  for (const key in allControllers) {
    const status = allControllers[key].getStatus()
    ifNotTrueExecute(status.valid && key !== 'dob', allControllers[key].validate)

    isValidForm = isValidForm && status.valid

    valuesForm[key] = status.value
  }

  const errors = document.querySelector('.week.error')

  if (!errors && isValidForm) {
    const userAgeAtStartOfPlan = stringToAge(
      dateToString(alterDate({ date: stringToDate(valuesForm.dob), days: 2 }))
    )

    toggleClass('#phone-container', 'd-none', !showPhoneInput)
    valuesForm.censusUrgency = coverageStartOption
    valuesForm.sdate = alterDate({ days: 1 })

    const spValue = buildSpValue(valuesForm)

    setAttribute(buttonSubmitId, 'data-sp-value', spValue)
    setAttribute(buttonSubmitId, 'data-placement', 'form-step-3')

    const initUser = ['fname', 'email', 'phone', 'dob'].reduce((acc, key) => {
      if (valuesForm[key]) acc[key] = valuesForm[key]
      return acc
    }, {})

    // So far use the email to decide to force a new session or not
    // More complex logic can be implemented later if needed
    const forceNewSession =
      valuesForm.email &&
      valuesForm.email !==
        propAccessor(store.getState(), 'hcStorage.contact.email_address')

    const submitOperations = [saveSession({ user: initUser }, forceNewSession)]
    if (valuesForm.phone?.trim()) submitOperations.push(submitLead(valuesForm))

    Promise.all(submitOperations)
      .catch(e => console.error(e))
      .finally(() => continueNavigation(userAgeAtStartOfPlan))
  } else {
    scrollToError()
    $(buttonSubmitId).prop('disabled', false)
  }
}

function continueNavigation(userAgeAtStartOfPlan) {
  subscribeAndSaveApplicant({ ...valuesForm, showPhoneInput }).then(() => {
    preventOnCloseEvent()
    const showDiscovery =
      coverageStartOption === 'immediately' &&
      userAgeAtStartOfPlan < 64 &&
      settingsDcp.enableDcp

    if (noCoverage) {
      const stateAcronym = storage.getItem('hc').location.state_acronym

      if (UHCStateAcronyms.includes(stateAcronym)) {
        window.location.href = 'https://www.pivothealth.com/short-term-medical-plans'
      } else {
        window.location.href = 'https://www.pivothealth.com/aca-health-insurance'
      }
      return false
    } else if (showOver65GapPage) {
      router.navigateTo('/over65')
      return false
    } else if (showDiscovery) {
      router.navigateTo('/customize-short-term-health-insurance')
    } else {
      finishAndNavigate()
    }
  })
}

const optionalInputs = {}

function makeFieldOptional(name) {
  if (!optionalInputs[name]) {
    optionalInputs[name] = false
    const node = document.querySelector(`[for=${name}]`)

    node.innerHTML = node.innerText + ' <small>(optional)</small>'
    controllers[name].makeOptional()
  }
}

export async function updateFormData(hcStorage) {
  setValuesFromURL()
  controllers.email.setValue(hcStorage.contact.email_address)
  controllers.phone.setValue(hcStorage.contact.phone_home)

  // update members information
  const applicant = findApplicant(hcStorage.members)
  if (applicant) {
    controllers.dob.setValue(applicant.stringDOB)
    if (applicant.dob) {
      controllers.dob.validate()
    }
    controllers.gender.setValue(applicant.gender)
    controllers.fname.setValue(applicant.firstName)
    handleMembers.loadMembers(hcStorage.members)

    handleMembers.applicantDateUpdated(applicant.stringDOB)
  }

  if (hcStorage.location.zip_code) {
    controllers.zip.setValue(hcStorage)

    await handleUpdateLocation(hcStorage)
  }
}

async function setValuesFromURL() {
  const urlParams = new URLSearchParams(window.location.search)
  const zip = urlParams.get('zip')
  if (zip) {
    await controllers.zip.setValue({ location: { zip_code: zip } })
  }
}
